import React, { useEffect, useState, useContext } from "react";
import { Box } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import { CuestionContext } from "../context/CuestionContext";

function RespuestasRadioButton({ preguntaActual }) {
  const { RespuestaSeleccionada, setRespuestaSeleccionada } = useContext(CuestionContext);

  const [alignment, setAlignment] = useState("2");
  const [isRespuestaSelecionada, setIsRespuestaSeleccionada] = useState(false);
  const { t, i18n } = useTranslation();
  const {loading} = useContext(CuestionContext)

  useEffect(() => {
    if (preguntaActual && preguntaActual.respuestas) {
      for (var i = 0; i < preguntaActual.respuestas.length; i++) {
        if (preguntaActual.respuestas[i].selecionada) {
          setRespuestaSeleccionada([preguntaActual.respuestas[i]]);
          setIsRespuestaSeleccionada(true);
          break;
        }
      }
    }
  }, [preguntaActual.respuestas]);

  function CambioRespuesta(value) {
    var respuestaElegida = preguntaActual.respuestas.find(
      respuesta => respuesta.id_respuesta.toString() === value
    );
    setRespuestaSeleccionada([respuestaElegida]);
  }

  return (
    <RadioGroup
      aria-labelledby="demo-row-radio-buttons-group-label"
      name="Respuestas"
      onChange={(e) => {
        CambioRespuesta(e.target.value);
      }}
    >
      {preguntaActual && preguntaActual.respuestas && preguntaActual.respuestas.length > 0 ? (
        preguntaActual.respuestas.map((respuesta) => (
          <Box key={respuesta.id_respuesta}
            sx={{
              textAlign: 'justify',
              marginBottom: '0.5em',
            }} >
            <FormControlLabel
            disabled={loading}
              value={respuesta.id_respuesta}
              control={<Radio />}
              label={respuesta.texto}
              checked={RespuestaSeleccionada?.length > 0 && respuesta.id_respuesta === RespuestaSeleccionada[0]?.id_respuesta}
            />
          </Box>
        ))
      ) : (
        <></>
      )}
    </RadioGroup>
  );
}

export default RespuestasRadioButton;
